module.exports = __webpack_public_path__ + "static/media/app_en.050a9e3c.png";